<template>
  <div class="video-background-container">
    <youtube-video v-if="isYoutube" :url="url" :thumb="thumb" />
  </div>
</template>

<script>
import YoutubeVideo from "@/components/auth/YoutubeVideo.vue";
export default {
  components: { YoutubeVideo },
  props: ["url", "thumb"],
  computed: {
    isYoutube() {
      return this.url.includes("youtu");
    }
  }
};
</script>

<style lang="scss" scoped>
.video-background-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
